<div class="container-fluid d-flex bg-secondary bg-shape-footer">
  <div class="container">
    <div class="row ptb-footer justify-content-between">
      <div class="col-xl-4 col-lg-6 col-12 align-self-center">
        <h1 class="title-footer">{{ footerInfo.Rodape_Titulo }}</h1>
      </div>
      <div class="col-lg-auto col-12 align-self-center mt-4 mt-lg-0 d-flex justify-content-center jus">
        <!--<a href="https://www.cimtamegaesousa.pt/" rel="noopener noreferrer" target="_blank" class="mx-3" aria-label="CIM Tâmega e Sousa"><img src="assets/img/logos/Tamega_Sousa_vertical.png" alt="Logo Tãmega e Sousa" class="img-fluid logo-douro-TMS-footer"></a>-->
        <a [routerLink]="'/'" class="float-lg-end" aria-label="Logo Linhas">
          <img src="assets/img/logos/linhas_main_logo.svg" alt="Logo Linhas" class="mx-3 img-fluid logo-footer">
        </a>
      </div>
    </div>
    <div class="row justify-content-lg-between justify-content-center py-4">
      <div class="col-xl-6 col-lg-6 col-12 d-inline-flex justify-content-lg-start justify-content-center align-items-center">
        <div class="d-sm-inline-flex d-block text-center text-lg-start">
          <div class="me-sm-4 m-0 text-center">
            <a [href]="phoneLink" aria-label="Contacto Telefónico" class="btn-number color-white"><i
              class="uil uil-phone-volume me-2 color-white"></i>{{ phoneNumberGeneral }}</a>
            <p class="subtitles-numbers-footer">{{ footerInfo.Rodape_Telefone_Texto_1 }}</p>
            <p class="subtitles-calls-footer">{{ footerInfo.Rodape_Telefone_Texto_2 }}</p>
          </div>
        </div>
      </div>
      <!--<div class="col-xl-6 col-lg-6 col-12 d-inline-flex justify-content-lg-end justify-content-center align-items-center">
        <div class="d-block">
          <p class="subtitles-footer px-3">{{footerInfo.Rodape_Redes_Sociais}}</p>
          <ul class="list-unstyled ul-social-media">
            <li class="li-social-media"><a aria-label="Facebook" href="#"><i class="uil uil-facebook-f"></i></a></li>
            <li class="li-social-media"><a aria-label="Instagram" href="#"><i class="uil uil-instagram"></i></a></li>
            <li class="li-social-media"><a aria-label="X" href="#"><i class="fa-brands fa-x-twitter"></i></a></li>
            <li class="li-social-media"><a aria-label="Linkedin" href="#"><i class="uil uil-linkedin"></i></a></li>
            <li class="li-social-media"><a aria-label="Youtube" href="#"><i class="uil uil-youtube"></i></a></li>
          </ul>
        </div>
        <a href="https://www.cimtamegaesousa.pt/" rel="noopener noreferrer" target="_blank" class="ms-4" aria-label="CIM Tâmega e Sousa"><img src="assets/img/logos/Tamega_Sousa_vertical.png" alt="Logo Tãmega e Sousa" class="img-fluid logo-douro-TMS-footer"></a>
      </div>-->
    </div>
    <div class="row justify-content-between align-items-center py-4 hr">
      <nav class="col" aria-label="Informações legais">
        <ul class="list-unstyled text-white d-lg-inline-flex d-block mb-0">
          <li class="prb-li-footer"><a [routerLink]="'/aviso-legal'" aria-label="Aviso Legal" class="nav-link-footer no-text-underline">{{ 'navLinks.avisoLegal' | translate }}</a></li>
          <li class="prb-li-footer"><a [routerLink]="'/politica-privacidade'" aria-label="Política e Privacidade" class="nav-link-footer no-text-underline">{{ 'navLinks.politicaPrivacidade' | translate }}</a></li>
          <li class="prb-li-footer"><a [routerLink]="'/politica-cookies'" aria-label="Política de Cookies" class="nav-link-footer no-text-underline">{{ 'navLinks.politicaCookies' | translate }}</a></li>
          <li class="prb-li-footer"><a [routerLink]="'/direitos-deveres'" aria-label="Direitos e Deveres dos Passageiros" class="nav-link-footer no-text-underline">{{ 'navLinks.direitosDeveresPassageiros' | translate }}</a>
          </li>
        </ul>
      </nav>
      <div class="col-auto">
        <div>
          <a href="https://www.livroreclamacoes.pt/Inicio/" aria-label="Livro de Reclamações" rel="noopener noreferrer"
             target="_blank" class="logo-livrorec-container align-middle">
            <img src="assets/img/logos/livro_reclam.png" alt="Livro de Reclamações"
                 class="img-fluid logo-livro-reclam img-default">
            <img src="assets/img/logos/livro_reclam_hover.png" alt="Livro de Reclamações (hover)"
                 class="img-fluid logo-livro-reclam img-hover">
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid d-flex bg-primary copyright-banner">
  <div class="container">
    <div class="row justify-content-md-between justify-content-center align-items-center py-3">
      <div class="col-auto text-center-mobile">
        <p *ngIf="feedVersion" class="fs-12px color-white mb-2"><span class="bold">Feed info: </span>{{ feedVersion }}</p>
        <p class="copyright-text">© {{ systemNameShort }} {{ year }} - {{ 'common.footerDireitos' | translate }}</p>
        <p class="fs-12px color-white m-0">{{ 'common.footerPoweredBy' | translate }} <a class="wgs-link" href="https://www.wegoshare.com/" aria-label="Wegoshare, Lda." rel="noopener noreferrer" target="_blank">{{ devByShort }}</a></p>
      </div>
      <div class="col-auto d-inline-flex p-0 mt-logo-responsive">
        <a href="https://www.cimtamegaesousa.pt/" rel="noopener noreferrer" aria-label="CIM Tâmega e Sousa" target="_blank"><img src="assets/img/logos/Tamega_Sousa_horizontal.png" alt="Logo CIM Tãmega e Sousa" class="img-fluid logo-operadores-footer px-2"></a>
        <a href="https://www.cimtamegaesousa.pt/" rel="noopener noreferrer" aria-label="Douro Tâmega e Sousa" target="_blank"><img src="assets/img/logos/Douro_Tamega_Sousa_horizontal.png" alt="Logo Tãmega e Sousa" class="img-fluid logo-operadores-footer px-2"></a>
      </div>
    </div>
  </div>
</div>

